<template>
  <Table.Row @row-click="$emit('select')">
    <template #media>
      <div class="size-6">
        <Thumbnail :type="thumbType" :src="thumbSrc ?? undefined" />
      </div>
    </template>

    <Table.Cell primary>
      <div v-truncate class="w-full">
        <div data-truncate-target>{{ name }}</div>
      </div>
    </Table.Cell>

    <Table.Cell class="w-[250px]">
      <slot name="col2" />
    </Table.Cell>
  </Table.Row>
</template>

<script setup lang="ts">
import { Table, Thumbnail, type ThumbnailType } from '@dacr/library'

defineProps<{
  thumbType: ThumbnailType
  thumbSrc?: string | null
  name: string
}>()

defineEmits<{ select: [] }>()
</script>
